const columns = [
  {
    title: '序号',
    width: 53,
    dataIndex: 'index',
    customRender: ({ index }) => index + 1,
  },
  {
    title: 'SKU规格',
    slots: { customRender: 'skuName' },
    align: 'left',
    width: 200,
  },
  {
    title: '来源价格',
    slots: { customRender: 'originPrice' },
    sorter: (a, b) => a.origin_price - b.origin_price,
    width: 140
  },
  {
    slots: { title: 'priceTitle', customRender: 'price' },
    sorter: (a, b) => a.price - b.price,
    width: 140
  },
  {
    dataIndex: 'originStockNum',
    title: '来源库存',
    slots: { customRender: 'originStockNum' },
    width: 140
  },
  {
    dataIndex: 'stock_num',
    slots: { title: 'stockNumTitle', customRender: 'stockNum' },
    width: 140
  }
]

export default {
  columns
}